import { isPast } from 'date-fns'

import { getDateFromAppointment } from '@lyrahealth-inc/shared-app-logic/src/features/appointments/getDateFromAppointment'
import { getEndDateFromAppointment } from '@lyrahealth-inc/shared-app-logic/src/features/appointments/getEndDateFromAppointment'
import { Appointment } from '@lyrahealth-inc/shared-app-logic/src/models/appointment/Appointment'
import { APPOINTMENT_STATUS } from '@lyrahealth-inc/shared-app-logic/src/models/session/Session'

export const isLateCancellation = (appointment: Appointment): boolean =>
  appointment.appointmentStatus === APPOINTMENT_STATUS.CANCELED && appointment.changeReason === 'clientInitiatedLate'

export const getAgendaAppointments = (appointments: Appointment[] = [], includeLateCancellations = false) => {
  const nonCanceled = appointments.filter(
    (appointment) =>
      ![APPOINTMENT_STATUS.CANCELED, APPOINTMENT_STATUS.MISSED].includes(
        appointment.appointmentStatus as APPOINTMENT_STATUS,
      ),
  )
  const visibleAppointments = appointments.filter(
    (appointment) =>
      (appointment.appointmentStatus === APPOINTMENT_STATUS.NEW_APPT ||
        (includeLateCancellations && isLateCancellation(appointment))) &&
      !isPast(getEndDateFromAppointment(appointment)),
  )

  if (includeLateCancellations) {
    visibleAppointments.sort((a, b) => getDateFromAppointment(a).getTime() - getDateFromAppointment(b).getTime())
  }

  return {
    visibleAppointments,
    allCompleted:
      visibleAppointments.length === 0 &&
      nonCanceled.length > 0 &&
      nonCanceled.every(
        (appointment) =>
          appointment.appointmentStatus === APPOINTMENT_STATUS.COMPLETED ||
          isPast(getEndDateFromAppointment(appointment)),
      ),
  }
}
